import { useCallback, useState } from "react";
import { ApiError } from "src/api/axiosClient/types";
import { buildFormData } from "../helpers";
import { usePlanService } from "../services";
import { Plan, PlanFormData } from "../types";

export interface CreateAdminPlanFormDrawerController {
  isOpen: boolean;
  initFormData: PlanFormData | null;
  error: ApiError | null;
  open: (plan?: Plan) => void;
  close: () => void;
  submit: (
    full: PlanFormData,
    dirty: Partial<PlanFormData>,
    nextAction?: () => unknown | Promise<unknown>
  ) => Promise<void>;
}

export const useCreateAdminPlanFormDrawerController = (): CreateAdminPlanFormDrawerController => {
  const [initFormData, setInitFormData] = useState<PlanFormData | null>(null);

  const { createPlan, updatePlan, error } = usePlanService();

  const open = useCallback((plan?: Plan) => {
    setInitFormData(buildFormData(plan));
  }, []);

  const close = useCallback(() => {
    setInitFormData(null);
  }, []);

  const submit = useCallback(
    async (full: PlanFormData, dirty: Partial<PlanFormData>, nextAction?: () => Promise<unknown>) => {
      const { id: planId, applicationId, ...requestData } = full;

      try {
        if (planId) {
          await updatePlan(planId, requestData);
        } else {
          await createPlan({ applicationId, ...requestData });
        }

        close();
        await nextAction?.();
      } catch (e) {
        console.log(e);
      }
    },
    []
  );

  return {
    isOpen: !!initFormData,
    initFormData,
    error,
    open,
    close,
    submit,
  };
};
